// Contrato do GET /fiscal/tax-config/tax-codes: a tela lê as consequências prontas, nunca mapeia CST.
export interface TaxCodeOption {
  code: string;
  description: string;
}

export interface CstIcmsCodigo extends TaxCodeOption {
  icmsProprio: boolean;
  substituicaoTributaria: boolean;
  porAliquota: boolean;
}

export interface CstPisCofinsCodigo extends TaxCodeOption {
  tributacao: string;
  exigeAliquota: boolean;
  aliquotaZero: boolean;
}

export interface CstIpiCodigo extends TaxCodeOption {
  sentido: 'SAIDA' | 'ENTRADA';
  incidencia: string;
  naoIncideNaNatureza: boolean;
  exigeAliquota: boolean;
  enquadramentoPadrao: string | null;
}

export interface TaxCodesData {
  cstIcms: CstIcmsCodigo[];
  csosn: CstIcmsCodigo[];
  cstPisCofins: CstPisCofinsCodigo[];
  cstIbsCbs: (TaxCodeOption & { id: number })[];
  cstIpi: CstIpiCodigo[];
}

export const TAX_CODES_VAZIO: TaxCodesData = { cstIcms: [], csosn: [], cstPisCofins: [], cstIbsCbs: [], cstIpi: [] };

export const normalizarTaxCodes = (dados: Partial<TaxCodesData> | null | undefined): TaxCodesData => ({
  cstIcms: dados?.cstIcms ?? [],
  csosn: dados?.csosn ?? [],
  cstPisCofins: dados?.cstPisCofins ?? [],
  cstIbsCbs: dados?.cstIbsCbs ?? [],
  cstIpi: dados?.cstIpi ?? [],
});

export const icmsPorAliquota = (codes: Pick<TaxCodesData, 'cstIcms' | 'csosn'>, code: string): boolean =>
  [...codes.cstIcms, ...codes.csosn].some((c) => c.code === code && c.porAliquota);
